<template>
    <div class="text-sm space-y-2">
        <p>Use this method if you added Stripe Payment Links using <a class="underline hover:no-underline" href="https://docs.stripe.com/payment-links/buy-button" target="_blank">Stripe Buy button</a> to your website.</p>
        <p>Partnero will automatically detect all Stripe buttons, and when a purchase is made via one of them, we’ll track it and send the data to your Partnero account.</p>
    </div>
    <div class="relative">
        <code-snippet :code="affiliateExample" language="javascript" v-if="programType === 'affiliate'" />
        <code-snippet :code="referralExample" language="javascript" v-else-if="programType === 'refer_a_friend'" />
        <small class="text-gray-500 mt-1 block">
            Include the following script on every page containing payment links. It's important to place
            this script at the bottom of the page, directly above the closing <span
            class="inline-flex items-center rounded bg-gray-100 px-2 py-0.5 text-xs text-gray-800">&lt;/body&gt;</span>
            tag for optimal functionality.
        </small>
    </div>
</template>

<script setup>

const props = defineProps({
    programId: {
        type: Number,
        required: true
    },
    config: {
        type: Object,
        default: null
    },
    programType: {
        type: String
    }
});

const affiliateExample = `<script>
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const stripeBuyButtons = document.getElementsByTagName('stripe-buy-button');
        const cookieValue = getCookieValue('partnero_partner');
        if (cookieValue) {
            for (let i = 0; i &lt; stripeBuyButtons.length; i++) {
                stripeBuyButtons[i].setAttribute('client-reference-id', decodeURIComponent(cookieValue));
            }
        }
    });

    function getCookieValue(cookieName) {
        const name = cookieName + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let i = 0; i &lt; ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
})();
</scr` + `ipt>`

const referralExample = `<script>
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const stripeBuyButtons = document.getElementsByTagName('stripe-buy-button');
        const cookieValue = getCookieValue('partnero_referral');
        if (cookieValue) {
            for (let i = 0; i &lt; stripeBuyButtons.length; i++) {
                stripeBuyButtons[i].setAttribute('client-reference-id', decodeURIComponent(cookieValue));
            }
        }
    });

    function getCookieValue(cookieName) {
        const name = cookieName + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let i = 0; i &lt; ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
})();
</scr` + `ipt>`

</script>

<style scoped>

</style>
